import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export const HomeAboutPreview = () => (
  <section className="py-20 md:py-28" data-testid="about-preview-section">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
        <div>
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#d3b163] mb-4 block">Sobre Nosotros</span>
          <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight text-stone-900 mb-6">
            Apoyo educativo con corazón en Dorado, Puerto Rico
          </h2>
          <p className="text-base text-stone-700 leading-relaxed mb-6">
            Rise & Shine Learning Zone es un centro educativo multidisciplinario que ofrece apoyo académico personalizado para estudiantes K-12. Con un enfoque cálido y profesional, creamos un ambiente donde cada niño puede alcanzar su máximo potencial.
          </p>
          <Link
            to="/sobre-nosotros"
            className="inline-flex items-center gap-2 text-[#43b6b8] font-semibold hover:gap-3 transition-all"
          >
            Conoce más sobre nosotros <ArrowRight className="w-5 h-5" />
          </Link>
        </div>
          <div className="rounded-2xl overflow-hidden shadow-[0_8px_30px_rgb(0,0,0,0.04)]">
            <img
              src="https://customer-assets.emergentagent.com/job_formando-lideres/artifacts/su36dezj_2ff8757f-3988-4aab-939d-8e91c0d638f2%20%281%29.jpeg"
              alt="Educadora apoyando a estudiante uno-a-uno en Rise & Shine Learning Zone"
              className="w-full h-full object-cover aspect-[4/5]"
              style={{ objectPosition: 'center center', filter: 'brightness(1.04) contrast(1.04) saturate(1.05)' }}
              loading="lazy"
            />
          </div>
      </div>
    </div>
  </section>
);
